import { Fetch } from 'lib';
import type {
  PaymentGatewayType,
  PurchaseSortType,
  PurchaseStatus,
  PurchaseSummary,
} from 'types';

type RequestResponses = {
  total: number;
  data: PurchaseSummary[];
};

type RequestParameters = {
  sortType: PurchaseSortType;
  statuses?: PurchaseStatus[];
  searchKey: string;
  lowerBoundCreateDate?: string;
  upperBoundCreateDate?: string;
  paymentGatewayType?: PaymentGatewayType;
  pageSize: number;
  pageNumber: number;
};

const searchPurchases = async ({
  sortType,
  statuses,
  searchKey,
  lowerBoundCreateDate,
  upperBoundCreateDate,
  paymentGatewayType,
  pageSize,
  pageNumber,
}: RequestParameters) => {
  const params: Record<string, unknown> = {
    sortType,
    searchKey,
    pageSize,
    pageNumber,
  };

  if (statuses) {
    params['statuses'] = statuses;
  }
  if (lowerBoundCreateDate) {
    params['lowerBoundCreateDate'] = lowerBoundCreateDate;
  }
  if (upperBoundCreateDate) {
    params['upperBoundCreateDate'] = upperBoundCreateDate;
  }
  if (paymentGatewayType) {
    params['paymentGatewayType'] = paymentGatewayType;
  }

  return await Fetch<RequestResponses, typeof params>({
    url: 'adminPurchase/searchPurchases',
    params,
  });
};

export { searchPurchases };
